/* MAIN */
const SYMBOL_CACHED = Symbol('Cached');
const SYMBOL_OBSERVABLE = Symbol('Observable');
const SYMBOL_OBSERVABLE_BOOLEAN = Symbol('Observable.Boolean');
const SYMBOL_OBSERVABLE_FROZEN = Symbol('Observable.Frozen');
const SYMBOL_OBSERVABLE_READABLE = Symbol('Observable.Readable');
const SYMBOL_OBSERVABLE_WRITABLE = Symbol('Observable.Writable');
const SYMBOL_STORE = Symbol('Store');
const SYMBOL_STORE_KEYS = Symbol('Store.Keys');
const SYMBOL_STORE_OBSERVABLE = Symbol('Store.Observable');
const SYMBOL_STORE_TARGET = Symbol('Store.Target');
const SYMBOL_STORE_VALUES = Symbol('Store.Values');
const SYMBOL_STORE_UNTRACKED = Symbol('Store.Untracked');
const SYMBOL_SUSPENSE = Symbol('Suspense');
const SYMBOL_UNCACHED = Symbol('Uncached');
const SYMBOL_UNTRACKED = Symbol('Untracked');
const SYMBOL_UNTRACKED_UNWRAPPED = Symbol('Untracked.Unwrapped');
/* EXPORT */
export { SYMBOL_CACHED, SYMBOL_OBSERVABLE, SYMBOL_OBSERVABLE_BOOLEAN, SYMBOL_OBSERVABLE_FROZEN, SYMBOL_OBSERVABLE_READABLE, SYMBOL_OBSERVABLE_WRITABLE, SYMBOL_STORE, SYMBOL_STORE_KEYS, SYMBOL_STORE_OBSERVABLE, SYMBOL_STORE_TARGET, SYMBOL_STORE_VALUES, SYMBOL_STORE_UNTRACKED, SYMBOL_SUSPENSE, SYMBOL_UNCACHED, SYMBOL_UNTRACKED, SYMBOL_UNTRACKED_UNWRAPPED };
